import React from 'react';
import {ConnectedRouter} from 'connected-react-router'
import {Provider} from 'react-redux';
import {Route, Switch} from 'react-router-dom';
import { ReactKeycloakProvider } from '@react-keycloak/web'
import keycloak from './keycloak'
import CircularProgress from './components/CircularProgress'

import configureStore, {history} from './store';
// import './firebase/firebase';
import App from './containers/App';

export const store = configureStore();

export const keycloakInitConfig = {
    onLoad: 'login-required'
};

const onKeycloakEvent = (event, error) => {
//   console.log('onKeycloakEvent', event, error);
};

const onKeycloakTokens = (tokens) => {
//   console.log('onKeycloakTokens', tokens);
};

const MainApp = () =>
  <ReactKeycloakProvider 
    authClient={keycloak} 
    initOptions={keycloakInitConfig}
    onEvent={onKeycloakEvent}
    onTokens={onKeycloakTokens}
    LoadingComponent={<CircularProgress/>}
  >
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Switch>
          <Route path="/" component={App}/>
        </Switch>
      </ConnectedRouter>
    </Provider>
  </ReactKeycloakProvider>;

export default MainApp;